(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["im-editable-factory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('im-factory-video')) {
  customElements.define('im-factory-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.playButton = this.querySelector('.im-factory-play');
      this.closeButton = this.querySelector('.im-factory-close');
      if (!this.playButton) return;
      this.playButton.addEventListener('click', () => this.start());
      this.closeButton.addEventListener('click', () => this.stop());
      this.addEventListener('keydown', event => { if (event.key === 'Escape') this.stop(); });
    }
    start() {
      document.querySelectorAll('im-factory-video[data-playing]').forEach(other => { if (other !== this) other.stop(false); });
      this.querySelector('.im-factory-error').hidden = true;
      if (!this.video) {
        this.append(this.querySelector('template').content.cloneNode(true));
        this.video = this.querySelector('video');
        this.video.addEventListener('ended', () => this.stop(false));
        this.video.addEventListener('error', () => this.fail());
      }
      this.setAttribute('data-playing', '');
      this.playButton.hidden = true;
      this.closeButton.hidden = false;
      this.video.hidden = false;
      this.video.play().then(() => this.video.focus()).catch(() => this.fail());
    }
    fail() {
      this.stop(false);
      this.querySelector('.im-factory-error').hidden = false;
    }
    stop(focus = true) {
      if (this.video) { this.video.pause(); this.video.hidden = true; this.video.currentTime = 0; }
      this.removeAttribute('data-playing');
      this.playButton.hidden = false;
      this.closeButton.hidden = true;
      if (focus) this.playButton.focus();
    }
    disconnectedCallback() { if (this.video) this.video.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
